import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import type { ColumnData, ItemData } from './KanbanBoard';
import { KanbanItem } from './KanbanItem';

interface KanbanColumnProps {
  column: ColumnData;
  items: ItemData[];
}

export function KanbanColumn({ column, items }: KanbanColumnProps) {
  const { setNodeRef, isOver } = useDroppable({
    id: column.id,
  });

  return (
    <div
      ref={setNodeRef}
      className={`flex flex-col flex-shrink-0 w-80 bg-gray-100 dark:bg-zinc-900 rounded-lg overflow-hidden h-full transition-colors ${isOver ? 'bg-gray-200 dark:bg-zinc-800' : ''}`}
    >
      <div className="p-4 font-semibold text-gray-700 dark:text-gray-300 border-b border-gray-200 dark:border-zinc-800">
        {column.title}
      </div>
      <div className="flex-1 p-3 overflow-y-auto min-h-[150px] flex flex-col gap-3">
        <SortableContext
          id={String(column.id)}
          items={items.map((item) => item.id)}
          strategy={verticalListSortingStrategy}
        >
          {items.map((item) => (
            <KanbanItem key={item.id} item={item} />
          ))}
        </SortableContext>
      </div>
    </div>
  );
}
